import { noop } from '@sweetgreen/garnish';

// Not available in web application.
export const useInAppReview = () => {
  return noop;
};
